import { initialState } from './initialState';

const name = () => ({
  ...initialState
});

export default name;
